import styles from "./Navbar.module.css";
import logo from "../assets/Home-care-logo.png";
import { Link } from "react-router-dom";
import { Image,Offcanvas,Nav  } from "react-bootstrap";
import { FaHome, FaInfoCircle, FaServicestack, FaPhone } from "react-icons/fa";
import { LuSearch, LuPhoneCall, LuNotepadText } from "react-icons/lu";
import { FaRegUser } from "react-icons/fa";
import { GrCart } from "react-icons/gr";
import { GrLocation } from "react-icons/gr";
import { IoIosArrowDown } from "react-icons/io";
import HLogo from "../assets/H.png";
import { IoMenuOutline } from "react-icons/io5";
import { FiMenu } from "react-icons/fi";
import React,{useState} from "react";
import { FiHome, FiUser, FiSearch, FiSettings, FiPhone, FiLogOut, FiUsers } from "react-icons/fi";
import { MdMiscellaneousServices } from "react-icons/md"
import { BiSolidOffer } from "react-icons/bi";
import { TbBrandBlogger } from "react-icons/tb";
import { IoDocumentTextOutline } from "react-icons/io5";
import { HiOutlineClipboardDocumentList } from "react-icons/hi2";
import { RiShakeHandsLine } from "react-icons/ri";
export default function Navbar() {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  return (
    <>
      <nav className={styles.navbar}>
        <div className={styles.navbarCenter}>
          <div className={styles.leftmenu}>
            <Link href="/">
              <Image
                src={logo} // Path to your image
                alt="Example Image"
                width={100}
                height={40}
              />
            </Link>
            <ul>
              <li>
                <div style={{ display: "flex", height: 45, marginTop: 10 }}>
                  <div
                    style={{
                      width: 45,
                      height: 45,
                      background: "#66D6FF",
                      borderRadius: 10,
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <GrLocation size={20} />
                  </div>
                  <div style={{ height: 45 }}>
                    <span
                      style={{
                        fontWeight: "300",
                        fontSize: 13,
                        marginLeft: 10,
                        color: "#13171B",
                      }}
                    >
                      Service Address
                    </span>
                    <br></br>
                    <span
                      style={{
                        fontWeight: "500",
                        fontSize: 13,
                        marginLeft: 10,
                        color: "#13171B",
                      }}
                    >
                      HSR Layout , Bangalore{" "}
                      <i className="bi bi-chevron-down"></i>
                    </span>
                  </div>
                </div>
              </li>
              <li>
                {" "}
                <Link
                  to={"/"}
                  style={{ textDecoration: "none", color: "#07448E" }}
                >
                  Home{" "}
                </Link>
              </li>
              <li>Service</li>
              <li>
                <Link
                  to={"/franchiseHome"}
                  style={{ textDecoration: "none", color: "#07448E" }}
                >
                  {" "}
                  Franchise
                </Link>
              </li>
              <li>
                {" "}
                <Link
                  to={"/partner"}
                  style={{ textDecoration: "none", color: "#07448E" }}
                >
                  Partner
                </Link>{" "}
              </li>

              
              {/* <li>Blog</li> */}
              <li>
                {" "}
                <Link
                  to={"/ContactUs"}
                  style={{ textDecoration: "none", color: "#07448E" }}
                >
                  Contact us
                </Link>{" "}
              </li>
            </ul>
          </div>
          <div className={styles.rightmenu}>
            <ul>
              <li>
                <Link to={"/Search"}>
                  <LuSearch size={22} />
                </Link>{" "}
              </li>
              {/* <li><Link href={""}><LuPhoneCall size={20}/></Link></li>
            <li><Link href={""}><LuNotepadText size={20}/></Link></li> */}
              <li>
                <Link href={""} to={"/SignIn"}>
                  <FaRegUser size={20} />
                </Link>
              </li>
              <li>
                <Link href={""} to={"/cartHome"}>
                  <GrCart size={20} />
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </nav>

      <div className={styles.mobile_navbar}>
        <div
          style={{
            width: "90%",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div
            style={{
              display: "flex",
              height: 45,
              marginTop: 10,
              justifyContent: "space-between",
            }}
          >
            <div
              style={{
                width: 45,
                height: 45,
                background: "#66D6FF",
                borderRadius: 10,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Image src={HLogo} style={{ width: 30, height: 30 }} />
            </div>
            <div style={{ height: 45 }}>
              <span
                style={{
                  fontWeight: "300",
                  fontSize: 13,
                  marginLeft: 10,
                  color: "#13171B",
                }}
              >
                Service Address
              </span>
              <br></br>
              <span
                style={{
                  fontWeight: "500",
                  fontSize: 13,
                  marginLeft: 10,
                  color: "#13171B",
                }}
              >
                HSR Layout , Bangalore{" "}
                <IoIosArrowDown style={{ marginLeft: 10, marginTop: 3 }} />
              </span>
            </div>
          </div>
          <div style={{display:"flex",justifyContent:"space-between",width:"15%"}}>
          <Link href={""} to={"/cartHome"}>
            <GrCart size={20} />
          </Link>
            <div onClick={()=>handleShow()} >
            <FiMenu size={20} color="#07448e" />
          </div>
          </div>
        </div>
      </div>

   <Offcanvas
  show={show}
  onHide={handleClose}
  responsive="lg"
  style={{
    width: "80%",
    maxWidth: 300,
    background: "#ffffff",
    boxShadow: "2px 0 12px rgba(0, 0, 0, 0.1)",
  }}
>
  <Offcanvas.Header
    closeButton
    style={{
      background: "linear-gradient(90deg, #ADE7FF, #DBF3FE)",
      color: "#07448E",
      paddingTop: 20,
      paddingBottom: 20,
      borderBottom: "1px solid #E0E0E0",
    }}
  >
    <Offcanvas.Title>
      <div>
        <h6 style={{ marginBottom: 4, fontWeight: 600 }}>Service Address</h6>
        <p style={{ fontSize: 12, marginBottom: 0, color: "#333" }}>
          123 Main Street, New York, NY 10001
        </p>
      </div>
    </Offcanvas.Title>
  </Offcanvas.Header>

  <Offcanvas.Body className={styles.hideOnDesktop}>
    <div style={{ padding: "1rem" }}>
      {[
        { to: "/", label: "Home", icon: <FiHome /> },
        { to: "/profile", label: "Profile", icon: <FiUser /> },
        { to: "/services", label: "Services", icon: <MdMiscellaneousServices /> },
        // { to: "/Search", label: "Search", icon: <FiSearch /> },
        { to: "/franchiseHome", label: "Franchise", icon: <FiUsers /> },
        { to: "/partner", label: "Partner", icon: <RiShakeHandsLine /> },
         { to: "/offer", label: "Offer", icon: <BiSolidOffer /> },
          { to: "/blog", label: "Blog", icon: <TbBrandBlogger /> },
           { to: "/privacy-policy", label: "Privacy Policy", icon: <IoDocumentTextOutline /> },
            { to: "/termAndCondition", label: "Terms & Conditions", icon: <HiOutlineClipboardDocumentList /> },
        { to: "/ContactUs", label: "Contact Us", icon: <FiPhone /> },
      ].map(({ to, label, icon }) => (
        <Link
          to={to}
          key={label}
          className="mb-3"
          style={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
            padding: "10px 10px",
            borderRadius: "8px",
            color: "#07448E",
            textDecoration: "none",
            fontWeight: 500,
            fontFamily: "Inter, sans-serif",
            transition: "all 0.2s ease",
          }}
          onMouseEnter={(e) =>
            (e.currentTarget.style.backgroundColor = "#F0FAFF")
          }
          onMouseLeave={(e) =>
            (e.currentTarget.style.backgroundColor = "transparent")
          }
        >
          <span style={{ fontSize: 18 }}>{icon}</span>
          {label}
        </Link>
      ))}

      <Link
        to="/logout"
        className="mt-3"
        style={{
          display: "flex",
          alignItems: "center",
          gap: "10px",
          padding: "10px 15px",
          borderRadius: "8px",
          backgroundColor: "#fff0f0",
          color: "#dc3545",
          textDecoration: "none",
          fontWeight: 600,
          fontFamily: "Inter, sans-serif",
          border: "1px solid #ffe5e5",
          transition: "all 0.2s ease",
        }}
        onMouseEnter={(e) =>
          (e.currentTarget.style.backgroundColor = "#ffe5e5")
        }
        onMouseLeave={(e) =>
          (e.currentTarget.style.backgroundColor = "#fff0f0")
        }
      >
        <FiLogOut size={18} />
        Log Out
      </Link>
    </div>
  </Offcanvas.Body>
</Offcanvas>
    </>
  );
}


const linkStyle = {
  textDecoration: 'none',
  color: '#000',
  paddingBottom: '8px',
  borderBottom: '1px solid #ccc',
  transition: 'color 0.2s',
};

const linkHoverStyle = {
  color: '#3c40c6',
};